/**
* Web Service handler to retrieve and represent a list of messages for the
* authenticated location administrator account
*
* @class MessagesWS
*/
function MessagesWS(parent) {
  var self = this; // Convenience reference so the context of 'this' becomes clearer

  // Predicate this Web Service handler on the Abstract class of a Web
  // Service handler. This establishes core functionality required of
  // these such handlers, which can be overwritten by methods below.
  AbstractWS.apply(this, arguments);

  self.activeLocale = ko.observable(null);
  self.allLanguages = ko.observableArray([]);
  self.allLanguageNames = ko.observableArray([]);
  self.bundle = ko.observable(null);
  self.bundles = [];
  self.localesParam = ko.observable('');
  self.name = 'MessagesWS';				// Convenience name for debugging
  self.phoneMask = ko.observable(null);


	/**
	* This computed observable returns the URL of the service endpoint
	*
	* @method serviceURL
	* @return {String}
	*/
  self.serviceURL = ko.computed(function () {
    return '';
  });


	/**
	* This computed observable returns the locale of the currently selected bundle
	*
	* @method activeLocale
	* @return {String|Null} The locale token of the current bundle
	*/
  self.activeLocale = ko.computed(function () {
    return (self.bundle() !== null) ? self.bundle().locale : null;
  });


	/**
	* Requests Message bundles from the API service
	*
	* @method doRequest
	* @param [Function] callback
	* @return none
	*/
  self.doRequest = function (callback) {

    self.serviceURL = ko.computed(function () {
      return '/qless/api/v1/messages/calendar/location/' + qcal.locationsWS.locationIds()[0] + '?locale=' + self.parent.locale();
    });

    AbstractWS.prototype.doRequest.call(self, callback);
  }


	/**
	* Method to retrieve text value of the provided key from the current bundle
	*
	* @method get
	* @param {String} sKey Token to use to find the text value from the bundle
	* @param {Boolean} bStripHTML Unless passed as false, HTML entities will be removed
	* @return {String}
	*/
  self.get = function (sKey, bStripHTML) {
    var i = 0,						// Standard increment
      aBundle = self.bundle(),	// Currently selected bundle
      oMessage = null,			// XML node corresponding to the key
      sVal = '';					// return value

    // If there is a bundle, else return an empty string
    if (aBundle != null) {

      var nMessages = $(aBundle).find('m');

      // Loop over the bundle's messages, looking for a node
      // with a corresponding key. If one if found, return the
      // string value, otherwise return an empty string
      for (i = 0; i < nMessages.length; i++) {
        // reference to the current message node
        oMessage = nMessages[i];

        // If the key if sound in the node
        if (oMessage.getAttribute('n') == sKey) {

          // If the node doesn't have a text value, disregard
          if (oMessage.firstChild == undefined) {
            break;
          }

          // Pull the text value into a return variable so
          // it can be manipulated
          sVal = oMessage.textContent;

          // Unless told not to, remove any HTML formatting
          if (bStripHTML !== false) {
            sVal = sVal.replace(/(<([^>]+)>)/ig, '');
          }

          //sVal = Strings.replaceNewlines( sVal );

          return sVal;
        }
      }

      // No matching text string was found; return an empty string
      return '';
    }

    // No bundle found; return an empty string
    return '';
  };



	/**
	* Determine's the language name based on a locale string
	*
	* @method languageName
	* @param {String} sLang language locale to find a bundle of
	* @return {String} Returns the language name in the current bundle translation
	*/
  self.languageName = function (sLang) {
    var i = 0,
      bundle = self.bundles[0],
      bundleIdent = sLang,
      node = null;

    if (sLang) {
      // Account for any country specific language separators like en_GB, es_US
      if (sLang.indexOf('_') > -1) {
        sLang = sLang.split('_')[0];
      }

      // Find the right bundle to use
      for (i = 0; i < self.bundles.length; i++) {
        if (self.bundles[i].getAttribute('locale').toLowerCase() == bundleIdent.toLowerCase()) {
          bundle = self.bundles[i];
        }
      }


      if (bundle) {
        node = $(bundle).find('m[n="language.' + sLang + '"]');

        if (node.length > 0) {
          return node.text();
        }
      }
    }

    return null;
  };


	/**
	* Sets the current bundle to the specified language string. If the language
	* string was not found, try to load the defaultLocale bundle. If a bundle
	* could still not be found, just load the first language bundle instead.
	*
	* @method setLocale
	* @param {String} sLang language locale to find a bundle of
	* @return {MessagesWS} Returns the object as chainable, for best practice
	*/
  self.setLocale = function (sLang) {
    var bundle = null,		// Instance of a message bundle
      bFound = false,		// Whether a matching bundle was found
      i = 0;				// Standard increment

    // If the language locale was not specified, don't bother
    if (sLang === null) {
      return;
    }

    // Start by trying to set the bundle to the requested bundle
    for (i = 0; i < self.bundles.length; i++) {
      bundle = self.bundles[i];

      if (bundle.getAttribute('locale').toLowerCase() == sLang.toLowerCase()) {
        bFound = true;
        self.bundle(bundle);
        break;
      }
    }

    // If the specified bundle (language name) could not be found, try to set it
    // to the defaultLocale() from the qcal.
    // if(!bFound){
    // 	for(i=0; i<self.bundles.length; i++){
    // 		bundle = self.bundles[i];
    // 		if(bundle.locale.toLowerCase() == self.VM.browserLocale.toLowerCase()){
    // 			bFound = true;
    // 			self.bundle(bundle);
    // 		}
    // 	}
    // }

    // If the requested bundle could not be found and the default language
    // bundle could not be found (accounting for logic error in the VM
    // defaultLocale() function), just set the bundle to the first bundle
    if (!bFound) {
      self.bundle(self.bundles[0]);
    }

    // Return self (MessagesWS) to be chainable, for best practice
    return self;
  };


	/**
	* This method processes the data returned from the service
	*
	* @method processData
	* @param {XMLString} xmlData XML data returned from the service
	* @return {MessagesWS} Returns the object as chainable, for best practice
	*/
  self.processData = function (xmlData) {

    // Call the superclass method to perform any core actions
    AbstractWS.prototype.processData.call(self, xmlData);

    self.bundles = $(xmlData).find('bundle');

    if (!self.bundles instanceof Array && self.bundles instanceof Object == true) {
      self.bundles = [self.bundles];
    }

    // Sets the initial bundle to the first one returned by the service
    self.setLocale(self.bundles[0].getAttribute('locale'));

    // Set the phoneMask
    self.phoneMask(self.get('phone.mask') || null);

    // Return self (MessagesWS) to be chainable, for best practice
    return self;

  };

  // Return self (MessagesWS)
  return self;
};


// Create a Knockout binding handler to make it easier to pull messages directly from
// the HTML files.
// The data-bind will look like: message: 'key'
ko.bindingHandlers.message = {
  init: function (element, valueAccessor, allBindingsAccessor, viewModel) {
    var data = valueAccessor(),
      defaultData = null,
      val = '';

    if (data instanceof Object) {
      defaultData = $.extend({
        text: '',
        sufix: '',
        prefix: ''
      }, data);

      $(element).html(qcal.messagesWS.get(defaultData.text) + defaultData.sufix);
    }
    else {
      try {
        val = qcal.messagesWS.get(data, true);

        if (val === '') {
          val = '???' + data + '???';
          if ($(element).attr('data-altText') != '') {
            val = $(element).attr('data-altText');
          }
        }

        $(element).html(val);
      }
      catch (e) { }
    }
  },
  update: function (element, valueAccessor, allBindingsAccessor, viewModel) {
    var data = valueAccessor(),
      defaultData = null,
      val = '';

    if (data instanceof Object) {
      defaultData = $.extend({
        text: '',
        sufix: '',
        prefix: ''
      }, data);

      $(element).html(defaultData.prefix + qcal.messagesWS.get(defaultData.text) + defaultData.sufix);
    }
    else {
      try {
        val = qcal.messagesWS.get(data, true);

        if (val === '') {
          val = '???' + data + '???';
          if ($(element).attr('data-altText') != '') {
            val = $(element).attr('data-altText');
          }
        }

        $(element).html(val);
      }
      catch (e) { }
    }
  }
};



// Create a Knockout binding handler to make it easier to pull messages directly from
// the HTML files as title attributes on elements
// The data-bind will look like: hint: 'key'
ko.bindingHandlers.hint = {
  init: function (element, valueAccessor, allBindingsAccessor, viewModel) {
    var data = valueAccessor(),
      defaultData = null,
      val = '';

    if (data instanceof Object) {
      defaultData = $.extend({
        text: '',
        sufix: '',
        prefix: ''
      }, data);

      $(element).html(qcal.messagesWS.get(defaultData.text) + defaultData.sufix);
    }
    else {
      try {
        val = qcal.messagesWS.get(data, true);

        if (val === '') {
          val = '???' + data + '???';

          if ($(element).attr('data-altText') != '') {
            val = $(element).attr('data-altText');
          }
        }

        $(element).attr('title', val);
        $(element).attr('alt', val);
      }
      catch (e) { }
    }
  },
  update: function (element, valueAccessor, allBindingsAccessor, viewModel) {
    var data = valueAccessor(),
      defaultData = null,
      val = '';

    if (data instanceof Object) {
      defaultData = $.extend({
        text: '',
        sufix: '',
        prefix: ''
      }, data);

      $(element).html(defaultData.prefix + qcal.messagesWS.get(defaultData.text) + defaultData.sufix);
    }
    else {
      try {
        val = qcal.messagesWS.get(data, true);

        if (val === '') {
          val = '???' + data + '???';

          if ($(element).attr('data-altText') != '') {
            val = $(element).attr('data-altText');
          }
        }

        $(element).attr('alt', val);
        $(element).attr('title', val);
      }
      catch (e) { }
    }
  }
};

MessagesWS.prototype = AbstractWS.prototype;
MessagesWS.prototype.constructor = AbstractWS;
